// src/helpers/documentUpload.js

// helpers/documentUpload.js
import axios from 'axios';

/**
 * Upload a file to your document-server and return { docId, path }
 * @param {File|Blob} file - The file to upload
 * @param {string} uid - The Firebase user UID
 * @returns {Promise<{ docId: string, path: string }>}
 */
export async function uploadUserDocument(file, uid) {
  if (!file || !uid) throw new Error("Missing file or UID");
  const formData = new FormData();
  formData.append('file', file);

  // Upload the document
  const response = await axios.post(
    `https://document-server-o7q2.onrender.com/api/users/${uid}/docs`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  // Response contains docId, path, etc.
  return {
    docId: response.data.docId,
    path: response.data.path,
    filename: response.data.filename,
  };
}
